import { BaseApi } from '../../../api/apiBase';
import type { V1Form, V1FormsResponse } from '../types/v1Forms.types';

class V1FormsApi extends BaseApi {
  constructor() {
    // Use the portal API endpoint - same as V2 forms
    super('/api/portal');
  }
  
  async getEventForms(eventSlug: string): Promise<V1FormsResponse> {
    // Use the V1-specific endpoint in portal namespace
    const path = `/events/${eventSlug}/v1/forms`;
    
    try {
      // Use get to get data from JSON:API response
      const response = await this.get<V1Form[]>(path);
      
      return {
        forms: response || []
      };
    } catch (error) {
      console.error('V1FormsApi error:', error);
      throw error;
    }
  }
}

export const v1FormsApi = new V1FormsApi();